import { createFileRoute, redirect } from '@tanstack/react-router'
import { ApiError } from '@/lib/api'
import { AppShell } from '@/shell/AppShell'
import { sessionQuery } from '@/shell/session'

/**
 * Every signed-in screen sits under this layout. Before it renders:
 *   no session            → /login?next=<here>
 *   no organisation yet    → /choose-org (which offers creating one)
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      const s = await context.queryClient.ensureQueryData(sessionQuery)
      if (!s.org && !location.pathname.startsWith('/me/')) {
        throw redirect({ to: '/choose-org' })
      }
      // The organisation requires two-step sign-in and this person has none yet.
      if ((s as { mfa_required_setup?: boolean }).mfa_required_setup && !location.pathname.startsWith('/me/')) {
        throw redirect({ to: '/me/security', search: { enrol: 1 } as never })
      }
      return { session: s }
    } catch (e) {
      if (e instanceof ApiError && e.isUnauthenticated) {
        throw redirect({ to: '/login', search: { next: location.href } as never })
      }
      throw e
    }
  },
  component: AppShell,
})
